import React, { useState } from "react";
import Helmet from "../components/Helmet";
import Paper from "@mui/material/Paper";
import { TextField, IconButton, Alert } from "@mui/material";
import { Button } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const Login = () => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [submit, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [field, setField] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [snackMessage, setSnackMessage] = useState("Email or password incorrect.");

  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setField((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const next = { email: "", password: "" };
    if (!field.email?.trim()) next.email = "Email is required.";
    else if (!EMAIL_REGEX.test(field.email)) next.email = "Please enter a valid email.";
    if (!field.password) next.password = "Password is required.";
    setErrors(next);
    return !next.email && !next.password;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);
    try {
      const { data } = await axios({
        method: "POST",
        url: "http://localhost:3000/auth/login",
        data: { email: field.email?.trim(), password: field.password },
      });
      if (data?.token) {
        localStorage.setItem("accessToken", data.token);
        setSubmitted(true);
      } else {
        setSnackMessage("Login failed. Please try again.");
        setOpen(true);
      }
    } catch (err) {
      const msg = err.response?.data?.message || err.message || "Email or password incorrect.";
      setSnackMessage(msg);
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  if (submit) {
    history.push("/");
    return null;
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  return (
    <Helmet title="Login">
      <div className="main_frame_login">
        <div className="Top_frame">
          <div className="sub_Frame">
            <header className="login_page_header">
              <PersonOutlineIcon className="login_page_icon" />
              <h1 className="login_page_title">Login</h1>
              <p className="login_page_subtitle">Welcome to our blog magazine Community</p>
            </header>

            <Paper className="main_paper" elevation={0}>
              <div className="frame_button_connect">
                <Button className="login_social_btn button_facebook" disableRipple>
                  <FacebookIcon className="login_social_icon" />
                  <span>Continue With Facebook</span>
                </Button>

                <Button className="login_social_btn button_google" disableRipple>
                  <svg className="login_social_icon_img" width="22" height="22" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                  </svg>
                  <span>Continue With Google</span>
                </Button>

                <Button className="login_social_btn button_twitter" disableRipple>
                  <TwitterIcon className="login_social_icon login_social_icon_twitter" />
                  <span>Continue With Twitter</span>
                </Button>

                <div className="login_divider">
                  <span className="login_divider_line" />
                  <span className="login_divider_text">OR</span>
                  <span className="login_divider_line" />
                </div>

                <div className="login_form_fields">
                  <label className="login_label">Email address</label>
                  <TextField
                    className="inputtextcricle"
                    fullWidth
                    type="email"
                    placeholder="e.g. you@example.com"
                    onChange={onChangeHandler}
                    value={field.email}
                    name="email"
                    error={!!errors.email}
                    helperText={errors.email}
                    autoComplete="email"
                    inputProps={{ "aria-label": "Email address" }}
                  />

                  <div className="login_password_row">
                    <label className="login_label">Password</label>
                    <Link to="/Forgotpass" className="login_link">
                      Forgot password?
                    </Link>
                  </div>
                  <TextField
                    className="inputtextcricle"
                    fullWidth
                    type="password"
                    placeholder="Enter your password"
                    onChange={onChangeHandler}
                    name="password"
                    value={field.password}
                    error={!!errors.password}
                    helperText={errors.password}
                    autoComplete="current-password"
                    inputProps={{ "aria-label": "Password" }}
                  />

                  <Button
                    className="button_login"
                    fullWidth
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? "Signing in…" : "Continue"}
                  </Button>
                  <Snackbar
                    open={open}
                    autoHideDuration={6000}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  >
                    <Alert
                      onClose={handleClose}
                      severity="error"
                      action={
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      }
                    >
                      {snackMessage}
                    </Alert>
                  </Snackbar>
                  <p className="login_signup_text">
                    New user? <Link to="/SignUp" className="login_link">Create an account</Link>
                  </p>
                </div>
              </div>
            </Paper>
          </div>
        </div>
      </div>
    </Helmet>
  );
};

export default Login;
